import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addEmployee,
  getEmployees,
  getEmployee,
  editEmployee,
  deleteEmployee,
  getAllEmployees,
} from "../../store/actions/employee_action";
import { SEARCH_TERMS } from "../enums/employees_enum";
// Get All Data
export const useAllEmployees = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.employee);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteEmployee(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getEmployees({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getEmployees({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getEmployees({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleEmployee = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.employee);
  useEffect(() => {
    dispatch(getEmployee(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateEmployee = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addEmployee(data));
  };
  return [addData];
};
export const useUpdateEmployee = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editEmployee(id, data));
  };
  return [updateData];
};

export const useSelectAllEmployee = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.employee);
    useEffect(() => {
      dispatch(getAllEmployees());
    }, []);
    return [data];
  };          